import React, { useState, useEffect } from "react";
import { Box, Button, Container, Popover, IconButton, MenuItem, TextField, FormControl, InputLabel, Select, FormHelperText, Typography, Tooltip, Autocomplete } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import CustomDataGridToolbar from '../../../common/customDataGridToolbar';
import { Add as AddIcon, Delete as DeleteIcon, CloudUpload as CloudUploadIcon, Close as CloseIcon } from '@mui/icons-material';
import Iconify from '../../components/iconify/Iconify';
import { 
  addUpdateDeleteLov, addMaterialList, editMaterialList, addRangeList, editBudgetList, 
  fetchUserList, addAggregatorList, editAggregatorList, addAggregatorHitMappingList, 
  editAggregatorHitMappingList, getUnmappedAggregatorList, fetchAggregatorHitMappingList, getListOfHit,
  addStorageLocation, editStorageLocation, deleteStorageLocation 
} from '../resourceCommonAPIs';
import { getCategoryUrnList } from "../rateCard/rateCardAPIs"; 
import { VALIDATION, capitalizeFunction, resourceMaxLength } from "../../../common/commonValidations";
import { ConfirmationPopover } from "../../../common/commonPopovers/confirmationPopover";
import { toast } from "react-toastify";
import { EditIcon } from "../../../common/icons";

function CommonLOVGrid(props) {
  const { arr, setMaterialListArr, setArr, selectedRow, setSelectedRow, lovType, lovText, applicationType, setBambooSPeciesArr, setSaplingTypeArr, setSaplingSourceArr, setBudgetRangeListArr, setAggregatorArr, setAggregatorHITMappingArr } = props;

  const [userList, setUserList] = useState();
  const [error, setError] = useState(false);
  const [hitList, setHitList] = useState();
  const [unmappedAggregatorList, setUmappedAggregatorList] = useState([]);
  const [storageUrnList, setStorageUrnList] = useState([]);

  useEffect(() => {
    fetchUserList(setUserList);
    getListOfHit(setHitList);
    getUnmappedAggregatorList(setUmappedAggregatorList);
  }, []);

  const [open, setOpen] = useState(null);
  const [lovResponse, setLovResponse] = useState();
  const [response, setResponse] = useState();
  const [details, setDetails] = useState({
    species: "",
    saplingType: "",
    saplingSource: "",
    materialValue: "",
    materialApplicationType: "",
    budgetValue: "",
    budgetApplicationType: "",
    aggregatorValue: "",
    aggregatorApplicationType: "",
    hitUrn: "",
    hitName: "",
    aggregatorId: "",
    stakeholderType: "",
    materialType: "",
    stakeholderUrn: "",
    stakeholderName: "",
    storageLocation: ""
  });
  const [logConfirmModalOpen, setLogConfirmModalOpen] = useState(false);
  
  const handleConfirmLogModalOpen = (row) => {
    setSelectedRow(row);
    setLogConfirmModalOpen(true);
  };
  const handleConfirmLogModalClose = () => setLogConfirmModalOpen(false);

  useEffect(() => {
    if (lovType === "aggregatorHitMapping" && response) {
      toast.success(response?.description);
    }
    else if (response) toast.error(response?.description);
  }, [response]);

  const handleStakeholderTypeChange = (e) => {
    const selectedType = e.target.value;
    
    if (selectedType === "Plant") {
      setDetails({
        ...details,
        stakeholderType: selectedType,
        stakeholderUrn: "ABEPL",
        stakeholderName: "ABEPL"
      });
      setStorageUrnList([]); 
    } else {
      setDetails({
        ...details,
        stakeholderType: selectedType,
        stakeholderUrn: "",  
        stakeholderName: ""
      });
      getCategoryUrnList(selectedType, setStorageUrnList);
    }
  };

  const handleUrnChange = (event, newValue) => {
    if (newValue) {
      if (typeof newValue === 'object') {
        setDetails({
          ...details,
          stakeholderUrn: newValue.urn || "",
          stakeholderName: newValue.stakeholderName || ""
        });
      } else {
        setDetails({
          ...details,
          stakeholderUrn: newValue,
          stakeholderName: "" 
        });
      }
    } else {
      setDetails({ ...details, stakeholderUrn: "", stakeholderName: "" });
    }
  };

  const onAddNew = () => {
    const currentArr = Array.isArray(arr) ? arr : [];
    const tempArr = [...currentArr];
    tempArr.unshift({
      id: null,
      [lovType]: "",
      type: "ADD",
      uniqueId: currentArr.length + 1,
      materialValue: "",
      materialApplicationType: "",
      budgetValue: "",
      budgetApplicationType: "",
      aggregatorValue: "",
      aggregatorApplicationType: "",
      hitUrn: "",
      aggregatorId: "",
      stakeholderType: "",
      materialType: "",
      stakeholderUrn: "",
      stakeholderName: "",
      storageLocation: ""
    });
    setArr(tempArr);
  };

  const handleChange = (e) => {
    setDetails({ ...details, [e.target.name]: VALIDATION.noSpecialCharacterValidation(e.target.value) })
  };

  const handleSelectChange = (e) => {
    setDetails({ ...details, [e.target.name]: e.target.value })
  };

  const handleApprovalChange = (e) => {
    setDetails({ ...details, budgetApplicationType: e.target.value })
  };

  const onAgChangeHandle = (e, value) => {
    e.preventDefault();
    setDetails({ ...details, aggregatorId: e.target.textContent })
  };

  const onHitChangeHandle = (e, value) => {
    e.preventDefault();
    setDetails({ ...details, hitUrn: e.target.textContent })
  };

  const handleBudgetChange = (e) => {
    const inputValue = e.target.value;
    const rangeRegex = /^\d*-?\d*$/;
    if (rangeRegex.test(inputValue)) {
      setDetails({ ...details, budgetValue: inputValue })
    }
    const parts = inputValue.split('-');
    if (parts.length === 2 && parts[0] !== '' && parts[1] !== '') {
      setError(false);
    } else {
      setError(true);
    }
  };

  const onCancel = () => {
    setOpen(false);
    setError(false);
    const currentArr = Array.isArray(arr) ? arr : [];
    const temArr = currentArr.filter(item => item.type !== "ADD");
    const newArr = temArr?.map(item => {
      if (item.type === 'UPDATE') {
        item.type = 'Existing'
      }
      return item
    });
    setArr(newArr);
    setSelectedRow(null);
    setDetails({
      ...details,
      [lovType]: "", materialValue: "", materialApplicationType: "", budgetValue: "", budgetApplicationType: "",
      aggregatorValue: "", aggregatorApplicationType: "", hitUrn: "", hitName: "", aggregatorId: "",
      stakeholderType: "", materialType: "", stakeholderUrn: "", stakeholderName: "", storageLocation: ""
    });
  };

  const onEdit = (row) => {
    setSelectedRow(row);
    setDetails({ 
      ...details, 
      [lovType]: row[lovType], 
      materialValue: row?.value, 
      materialApplicationType: row?.applicationKey, 
      budgetValue: row?.value, 
      budgetApplicationType: row?.applicationKey, 
      aggregatorValue: row?.value, 
      aggregatorApplicationType: row?.applicationKey, 
      hitUrn: row?.hitUrn, 
      hitName: row?.hitName, 
      aggregatorId: row?.aggregatorId,
      stakeholderType: row?.stakeholderType || "",
      materialType: row?.materialType || "",
      stakeholderUrn: row?.stakeholderUrn || "",
      stakeholderName: row?.stakeholderName || "",
      storageLocation: row?.storageLocation || ""
    });
    
    if (row?.stakeholderType && row.stakeholderType !== "Plant") {
      getCategoryUrnList(row.stakeholderType, setStorageUrnList);
    } else {
      setStorageUrnList([]);
    }

    const currentArr = Array.isArray(arr) ? arr : [];
    const newArr = currentArr?.map(item => {
      const matchCondition = row.id ? item.id === row.id : item.uniqueId === row.uniqueId;
      if (matchCondition) {
        item.type = 'UPDATE'
      } else {
        item.type = 'Existing'
      }
      return item;
    });
    setArr(newArr);
  };

  const onSave = (row, Delete) => {
    if (error) {
      toast.error("Please enter a valid range (e.g., 0-1000)");
      return;
    }
    if (lovType === "budgetRange" && details.budgetApplicationType === "") {
      toast.error("Please Select Budget Approver!");
      return;
    }
    
    if (lovType === "storageLocation") {
      if (!details.stakeholderType || !details.stakeholderUrn || !details.materialType || !details.storageLocation) {
        toast.error("Please fill in all required fields (Type, URN, Material, Storage Code) before saving!");
        return; 
      }

      const isDuplicate = Array.isArray(arr) && arr.some(existingItem => {
        const isCurrentRow = (existingItem.id && existingItem.id === row.id) || (existingItem.uniqueId && existingItem.uniqueId === row.uniqueId);
        if (isCurrentRow) return false;

        return (
          existingItem.stakeholderUrn === details.stakeholderUrn &&
          existingItem.materialType === details.materialType &&
          existingItem.storageLocation === details.storageLocation
        );
      });

      if (isDuplicate) {
        toast.error("Duplicate Entry! This combination of URN, Material Type, and Storage Code already exists.");
        return;
      }
    }

    if (lovType === "materialList" && row.type === "ADD") addMaterialList(details, setMaterialListArr);
    else if (lovType === "materialList" && row.type === "UPDATE") editMaterialList(details, row, setMaterialListArr);
    else if (lovType === "budgetRange" && row.type === "ADD") addRangeList(details, setBudgetRangeListArr);
    else if (lovType === "budgetRange" && row.type === "UPDATE") editBudgetList(details, row, setBudgetRangeListArr);
    else if (lovType === "aggregatorId" && row.type === "ADD") addAggregatorList(details, setAggregatorArr);
    else if (lovType === "aggregatorId" && row.type === "UPDATE") editAggregatorList(details, row, setAggregatorArr);
    else if (lovType === "aggregatorHitMapping" && row.type === "ADD") addAggregatorHitMappingList(details, setAggregatorHITMappingArr, setHitList, setUmappedAggregatorList, setResponse);
    else if (lovType === "aggregatorHitMapping" && row.type === "UPDATE") editAggregatorHitMappingList(details, row, setAggregatorHITMappingArr, setHitList, setUmappedAggregatorList, setResponse);
    
    else if (lovType === "storageLocation" && row.type === "ADD") {
      const addPayload = {
        stakeholderType: details.stakeholderType,
        materialType: details.materialType,
        stakeholderUrn: details.stakeholderUrn,
        stakeholderName: details.stakeholderName,
        storageLocation: details.storageLocation
      };
      addStorageLocation(addPayload, setArr);
    }
    else if (lovType === "storageLocation" && row.type === "UPDATE") {
      const editPayload = {
        id: row.id,
        stakeholderType: details.stakeholderType,
        materialType: details.materialType,
        stakeholderUrn: details.stakeholderUrn,
        stakeholderName: details.stakeholderName,
        storageLocation: details.storageLocation,
        createdOn: row.createdOn,
        createdBy: row.createdBy,
        isActive: row.isActive,
        updatedOn: null,
        updatedBy: null
      };
      editStorageLocation(editPayload, setArr);
    }
    else {
      addUpdateDeleteLov("Plantation", details[lovType], applicationType, Delete ? Delete : row.type, row.id, setLovResponse, setBambooSPeciesArr, setSaplingTypeArr, setSaplingSourceArr);
    }
    
    setSelectedRow(null);
    setDetails({ ...details, [lovType]: "", materialValue: "", materialApplicationType: "", budgetValue: "", budgetApplicationType: "", aggregatorValue: "", aggregatorApplicationType: "", hitUrn: "", hitName: "", aggregatorId: "", stakeholderType: "", materialType: "", stakeholderUrn: "", stakeholderName: "", storageLocation: "" });
  };

  function onConfirmCallBack() {
    if(lovType === "storageLocation" && selectedRow) {
      const deletePayload = {
        id: selectedRow.id,
        stakeholderType: selectedRow.stakeholderType,
        materialType: selectedRow.materialType,
        stakeholderUrn: selectedRow.stakeholderUrn,
        stakeholderName: selectedRow.stakeholderName,
        storageLocation: selectedRow.storageLocation,
        createdOn: selectedRow.createdOn,
        createdBy: selectedRow.createdBy,
        isActive: selectedRow.isActive,
        updatedOn: selectedRow.updatedOn,
        updatedBy: selectedRow.updatedBy
      };
      deleteStorageLocation(deletePayload, setArr);
    } else {
      addUpdateDeleteLov("Plantation", details[lovType], applicationType, "DELETE", selectedRow.id, setLovResponse, setBambooSPeciesArr, setSaplingTypeArr, setSaplingSourceArr)
    }
    setDetails({ ...details, [lovType]: "" });
    setSelectedRow(null);
    handleConfirmLogModalClose();
  }

  function onCancelBack() {
    handleConfirmLogModalClose();
  }

  const handleKeyDownCommon = (event) => {
    if (event.key === ' ') {
      event.stopPropagation();
    }
  };

  const isRowEditable = (row) => {
    if (!row || !selectedRow) return row?.type === "ADD";
    if (row.type === "ADD") return true;
    if (row.type === "UPDATE") {
      return row.id ? row.id === selectedRow.id : row.uniqueId === selectedRow.uniqueId;
    }
    return false;
  };

  const columns = [
  {
    field: lovType, 
    headerName: lovText, 
    width: 300,
    valueGetter: (params) => { return isRowEditable(params?.row) ? details[lovType] : params.row[lovType] },
    renderCell: (params) => {
      return (
        isRowEditable(params?.row) ?
          <TextField fullWidth label={lovText} inputProps={{ maxLength: resourceMaxLength }} size="small" name={lovType} onKeyDown={handleKeyDownCommon} value={details[lovType]} onChange={(e) => handleChange(e)} />
          : params.row[lovType]
      );
    }, 
    hide: ["materialList", "budgetRange", "aggregatorId", "aggregatorHitMapping", "storageLocation"].includes(lovType)
  },
  {
    field: "value", headerName: "Material Code", width: 150,
    valueGetter: (params) => { return isRowEditable(params?.row) ? details.materialValue : params.row.value },
    renderCell: (params) => {
      return (
        isRowEditable(params?.row) ?
          <TextField fullWidth label="Material Code" inputProps={{ maxLength: resourceMaxLength }} size="small" name="materialValue" value={details.materialValue} onKeyDown={handleKeyDownCommon} onChange={(e) => handleChange(e)} />
          : params.row.value
      );
    }, hide: lovType !== "materialList" ? true : false
  },
  {
    field: "applicationKey", headerName: "Material Type", width: 150,
    valueGetter: (params) => { return isRowEditable(params?.row) ? details.materialApplicationType : params.row.applicationKey },
    renderCell: (params) => {
      return (
        isRowEditable(params?.row) ?
          <TextField fullWidth label="Material Type" inputProps={{ maxLength: resourceMaxLength }} size="small" value={details.materialApplicationType} name="materialApplicationType" onKeyDown={handleKeyDownCommon} onChange={(e) => handleChange(e)} />
          : params.row.applicationKey
      );
    }, hide: lovType !== "materialList" ? true : false
  },
  {
    field: "budgetValue", headerName: "Budget Range", width: 170,
    valueGetter: (params) => { return isRowEditable(params?.row) ? details.budgetValue : params.row.value },
    renderCell: (params) => {
      return (
        isRowEditable(params?.row) ?
          <TextField fullWidth label="Budget Range(0-10)" size="small" value={details?.budgetValue} name="budgetValue" onChange={(e) => handleBudgetChange(e)} error={error} />
          : params.row.value
      );
    }, hide: lovType !== "budgetRange" ? true : false
  },
  {
    field: "budgetApplicationType", headerName: "Final Budget Approval", width: 180,
    valueGetter: (params) => { return isRowEditable(params?.row) ? details.budgetApplicationType : params.row.applicationKey },
    renderCell: (params) => {
      return (
        isRowEditable(params?.row) ?
          <FormControl fullWidth size="small">
            <InputLabel>Final Budget Approval</InputLabel>
            <Select value={details.budgetApplicationType} label="Final Budget Approval" onChange={(e) => handleApprovalChange(e)}>
              <MenuItem disabled value=""> -- select an option -- </MenuItem>
              {userList?.map((item) => (
                <MenuItem key={item} value={item}>{item}</MenuItem>
              ))}
            </Select>
          </FormControl>
          : params.row.applicationKey
      );
    }, hide: lovType !== "budgetRange" ? true : false
  },
  {
    field: "aggregatorValue", headerName: "Aggregator ID", width: 250,
    valueGetter: (params) => { return isRowEditable(params?.row) ? details.aggregatorValue : params.row.value },
    renderCell: (params) => {
      return (
        isRowEditable(params?.row) ?
          <TextField fullWidth label={lovText} size="small" value={details?.aggregatorValue} name="aggregatorValue" onChange={(e) => handleChange(e)} error={error} />
          : params.row.value
      );
    }, hide: lovType !== "aggregatorId" ? true : false
  },
  {
    field: "hitName", headerName: "HIT Name", width: 200,
    valueGetter: (params) => { return params.row.hitName },
    renderCell: (params) => { return params?.row?.hitName; }, 
    hide: lovType !== "aggregatorHitMapping" ? true : false
  },
  {
    field: "hitUrn", headerName: "HIT URN", width: 300,
    valueGetter: (params) => { return isRowEditable(params?.row) ? details.hitUrn : params.row.hitUrn },
    renderCell: (params) => {
      return (
        isRowEditable(params?.row) ?
          <Autocomplete id="combo-box-hit" options={hitList?.map((item) => item.urn) ? hitList?.map((item) => item.urn + "(" + item.name + ")") : []} sx={{ width: '100%' }} size='small' value={details?.hitUrn} onChange={(e, newInputValue) => onHitChangeHandle(e, newInputValue)} renderInput={(params) => <TextField {...params} label="HIT URN" />} />
          : params.row.hitUrn
      );
    }, hide: lovType !== "aggregatorHitMapping" ? true : false
  },
  {
    field: "aggregatorId", headerName: "Aggregator ID", width: 260,
    valueGetter: (params) => { return isRowEditable(params?.row) ? details.aggregatorId : params.row.aggregatorId },
    renderCell: (params) => {
      return (
        isRowEditable(params?.row) ?
          <Autocomplete id="combo-box-agg" options={unmappedAggregatorList?.map((item) => item.value) || []} sx={{ width: '100%' }} size='small' value={details?.aggregatorId} onChange={(e, newInputValue) => onAgChangeHandle(e, newInputValue)} renderInput={(params) => <TextField {...params} label="Aggregator ID" />} />
          : params.row.aggregatorId
      );
    }, hide: lovType !== "aggregatorHitMapping" ? true : false
  },
  // ---------------- STORAGE LOCATION COLUMNS ----------------
  {
    field: "stakeholderType", headerName: "Stakeholder Type", width: 170,
    valueGetter: (params) => { return isRowEditable(params?.row) ? details.stakeholderType : params.row.stakeholderType },
    renderCell: (params) => {
      return (
        isRowEditable(params?.row) ?
          <FormControl fullWidth size="small">
            <InputLabel>Stakeholder Type</InputLabel>
            <Select name="stakeholderType" value={details.stakeholderType} label="Stakeholder Type" onChange={handleStakeholderTypeChange}>
              <MenuItem value="LLE">LLE</MenuItem>
              <MenuItem value="Plant">Plant</MenuItem>
            </Select>
          </FormControl>
          : params.row.stakeholderType
      );
    }, hide: lovType !== "storageLocation" ? true : false
  },
  {
    field: "stakeholderUrn", 
    headerName: "Stakeholder URN", 
    width: 220,
    valueGetter: (params) => { 
      return isRowEditable(params?.row) ? details.stakeholderUrn : params.row.stakeholderUrn 
    },
    renderCell: (params) => {
      return (
        isRowEditable(params?.row) ?
          (details.stakeholderType === "Plant" ? (
            <TextField fullWidth disabled label="Stakeholder URN" size="small" value={details.stakeholderUrn || ""} />
          ) : (
            <Autocomplete 
              disabled={!details.stakeholderType} // DISABLING UNTIL TYPE IS CHOSEN
              options={storageUrnList || []} 
              getOptionLabel={(option) => {
                if (typeof option === 'string') return option;
                return option.urn ? `${option.urn} (${option.stakeholderName})` : "";
              }}
              isOptionEqualToValue={(option, value) => {
                const optUrn = typeof option === 'string' ? option : option.urn;
                const valUrn = typeof value === 'string' ? value : value.urn;
                return optUrn === valUrn;
              }}
              sx={{ width: '100%' }} 
              size='small' 
              value={storageUrnList?.find(item => (typeof item === 'string' ? item : item.urn) === details.stakeholderUrn) || null} 
              onChange={handleUrnChange} 
              renderInput={(params) => <TextField {...params} label="Stakeholder URN" />} 
            />
          ))
          : params.row.stakeholderUrn
      );
    }, 
    hide: lovType !== "storageLocation"
  },
  {
    field: "stakeholderName", headerName: "Stakeholder Name", width: 180,
    valueGetter: (params) => { return isRowEditable(params?.row) ? details.stakeholderName : params.row.stakeholderName },
    renderCell: (params) => {
      return (
        isRowEditable(params?.row) ?
          <TextField fullWidth disabled label="Stakeholder Name" size="small" name="stakeholderName" value={details.stakeholderName || ""} InputLabelProps={{ shrink: true }} />
          : params.row.stakeholderName
      );
    }, hide: lovType !== "storageLocation" ? true : false
  },
  {
    field: "materialType", headerName: "Material Type", width: 170,
    valueGetter: (params) => { return isRowEditable(params?.row) ? details.materialType : params.row.materialType },
    renderCell: (params) => {
      return (
        isRowEditable(params?.row) ?
          <FormControl fullWidth size="small">
            <InputLabel>Material Type</InputLabel>
            <Select name="materialType" value={details.materialType} label="Material Type" onChange={(e) => setDetails({ ...details, materialType: e.target.value })}>
              <MenuItem value="RawBamboo">RawBamboo</MenuItem>
              <MenuItem value="ChipBamboo">ChipBamboo</MenuItem>
            </Select>
          </FormControl>
          : params.row.materialType
      );
    }, hide: lovType !== "storageLocation" ? true : false
  },
  {
    field: "storageLocationCodeKey", 
    headerName: "Storage Code", 
    width: 150,
    valueGetter: (params) => { 
      return isRowEditable(params?.row) ? details.storageLocation : params.row.storageLocation; 
    },
    renderCell: (params) => {
      return (
        isRowEditable(params?.row) ?
          <TextField 
            fullWidth 
            label="Storage Code" 
            size="small" 
            name="storageLocation" 
            onKeyDown={handleKeyDownCommon} 
            value={details.storageLocation} 
            onChange={(e) => handleChange(e)} 
          />
          : params.row.storageLocation
      );
    }, 
    hide: lovType !== "storageLocation" ? true : false
  },
  {
    field: "actions", headerName: "Actions", sortable: false, width: 150, disableClickEventBubbling: true,
    renderCell: (params) => {
      return (
        isRowEditable(params?.row) ?
          <>
            <Button variant="contained" onClick={() => onSave(params.row)}> Save </Button>
            <Button sx={{ ml: 1 }} variant="outlined" onClick={() => onCancel()}> Cancel </Button>
          </>
          :
          <>
            <Tooltip title="Edit">
              <IconButton color="primary" size="small" onClick={(e) => onEdit(params.row)}>
                <EditIcon />
              </IconButton>
            </Tooltip>
            {lovType === "storageLocation" && (
              <Tooltip title="Delete">
                <IconButton color="error" size="small" onClick={(e) => handleConfirmLogModalOpen(params.row)}>
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            )}
          </>
      );
    }
  }];

  const validatedRows = Array.isArray(arr) ? arr : [];

  return (
    <>
      <Button sx={{ mb: 1 }} disabled={validatedRows.some(item => item.type === 'ADD' || item.type === 'UPDATE')} onClick={() => onAddNew()} variant="contained" startIcon={<AddIcon />}>
        Add New {lovText}
      </Button>
      <Typography color="red">
        {error ? 'Please enter a valid range (e.g., 0-1000)' : ''}
      </Typography>
      <Box style={{ height: lovType === "aggregatorHitMapping" || lovType === "storageLocation" ? 450 : 280, width: '100%' }}>
        <DataGrid
          rows={validatedRows}
          columns={columns}
          pageSize={5}
          getRowId={(row) => row?.uniqueId || row?.id}
          components={{ Toolbar: CustomDataGridToolbar }}
          componentsProps={{ toolbar: { rows: validatedRows, columns: columns, fileName: lovText + ".xlsx" } }}
        />
      </Box>
      <ConfirmationPopover onOpen={logConfirmModalOpen} onConfirm={onConfirmCallBack} onClose={onCancelBack} action="Delete" />
    </>
  );
}
export default CommonLOVGrid;
